import { useCallback, useContext, useEffect, useState } from 'react'

import { Button, Text, getCurrentBaseUrl, theme } from '@hhgtech/hhg-components'
import { Badge, Carousel } from '@hhgtech/hhg-components/mantine'
import { Embla } from '@mantine/carousel'
import { redirectToSSOWithReturnUrl } from 'api/utils'
import { useIsMobile } from 'hooks/useIsMobile'
import { TogetherTopic } from 'interfaces/types'
import { AppContext } from 'state/appContext'

import { EmotionBadge, StyledCarousel } from './index.styled'

export const TopicScrollList = ({
  topics: _topics,
  communitySlug,
}: {
  topics?: Array<TogetherTopic>
  communitySlug?: string
}) => {
  const isMobile = useIsMobile()
  const {
    state: { isLoggedIn },
  } = useContext(AppContext)
  // const { formatMessage: f } = useIntl()
  const [embla, setEmbla] = useState<Embla | null>(null)
  const [shouldAllowClick, setShouldAllowClick] = useState(true)
  const handleScroll = useCallback(() => {
    setShouldAllowClick(false)
  }, [])

  const handlePointerUp = useCallback(() => {
    setTimeout(() => {
      setShouldAllowClick(true)
    }, 1000)
  }, [])

  useEffect(() => {
    if (embla) {
      embla.on('scroll', handleScroll)
      embla.on('pointerUp', handlePointerUp)
    }
    return () => {
      if (embla) {
        embla.off('scroll', handleScroll)
        embla.on('pointerUp', handlePointerUp)
      }
    }
  }, [embla, handleScroll, handlePointerUp])

  if (!_topics) return <></>
  // const showMoreOption = _topics.length > 3 && !isMobile
  const topics = _topics
  // _topics.length <= 3 ? _topics : isMobile ? _topics : _topics.slice(0, 3)

  const onTopicClick = (topic: TogetherTopic) => {
    if (!shouldAllowClick) return
    if (!isLoggedIn) {
      redirectToSSOWithReturnUrl(
        `${getCurrentBaseUrl(
          'vi-VN',
          true,
        )}/community/on-boarding/?returnUrl=/${communitySlug}/${topic?.slug}`,
        'communities',
        'embeddedarticle',
        `${communitySlug}/${topic?.slug}`,
      )
    } else {
      window.location.href = `${getCurrentBaseUrl(
        'vi-VN',
        true,
      )}/community/${communitySlug}/${topic?.slug}`
    }
  }
  // const onMoreClick = () => {
  //   if (!isLoggedIn) {
  //     redirectToSSOWithReturnUrl(
  //       `${getHelloSitesUrl(
  //         locale,
  //       )}/community/on-boarding/?returnUrl=/${communitySlug}/`,
  //       'communities',
  //       'embeddedarticle',
  //       `${communitySlug}/`,
  //     )
  //   } else {
  //     window.location.href = `${getHelloSitesUrl(
  //       locale,
  //     )}/community/${communitySlug}`
  //   }
  // }

  // return (
  //   <StyledScrollArea type="hover" offsetScrollbars scrollbarSize={2}>
  //     <div style={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
  //       {topics.map((topic) => (
  //         <Badge key={topic.id} color="#ffffff" styles={EmotionBadge}>
  //           <Button
  //             color="transparent"
  //             size="sm"
  //             onClick={() => onTopicClick(topic)}
  //             data-event-category="Together"
  //             data-event-action="Join Topic"
  //             data-event-label={`${getHelloSitesUrl(
  //               locale,
  //             )}/community/on-boarding/?returnUrl=/${communitySlug}/${
  //               topic?.slug
  //             }`}
  //             className="pointer-event-child-none"
  //           >
  //             <Text size="p3" color={theme.colors.gray600}>
  //               {topic.name}
  //             </Text>
  //           </Button>
  //         </Badge>
  //       ))}
  //       {showMoreOption && (
  //         <Badge color="#ffffff" styles={EmotionBadge}>
  //           <Button
  //             color="transparent"
  //             size="sm"
  //             onClick={onMoreClick}
  //             data-event-category="Together"
  //             data-event-action="Other Topic Click"
  //             data-event-label={`${getHelloSitesUrl(
  //               locale,
  //             )}/community/${communitySlug}`}
  //             className="pointer-event-child-none"
  //           >
  //             <Text size="p3" color={theme.colors.primaryBase} type="semiBold">
  //               {f({
  //                 id: 'embeddedCommunity.moreForums',
  //                 defaultMessage: 'More forums',
  //               })}
  //             </Text>
  //           </Button>
  //         </Badge>
  //       )}
  //     </div>
  //   </StyledScrollArea>
  // )
  return topics && topics.length > 0 ? (
    <StyledCarousel
      align="start"
      slideGap="md"
      // dragFree
      // withControls={false}
      slideSize="10%"
      styles={{
        root: {
          width: !isMobile ? '460px' : '100%',
        },
      }}
      getEmblaApi={setEmbla as any}
      // withControls={false}
      controlsOffset={-26}
    >
      {topics.map((topic) => (
        <Carousel.Slide key={topic.id}>
          <Badge color="#ffffff" styles={EmotionBadge}>
            <Button
              color="transparent"
              size="sm"
              onClick={() => onTopicClick(topic)}
              data-event-category="Together"
              data-event-action="Embedded Other Topic Click"
              data-event-label={`${getCurrentBaseUrl(
                'vi-VN',
                true,
              )}/community/${communitySlug}/${topic?.slug}`}
              className="pointer-event-child-none"
            >
              <Text size="p4" color={theme.colors.gray600}>
                {topic.name}
              </Text>
            </Button>
          </Badge>
        </Carousel.Slide>
      ))}
      {/* {showMoreOption && (
        <Carousel.Slide>
          <Badge color="#ffffff" styles={EmotionBadge}>
            <Button
              color="transparent"
              size="sm"
              onClick={onMoreClick}
              data-event-category="Together"
              data-event-action="Other Topic Click"
              data-event-label={`${getHelloSitesUrl(
                locale,
              )}/community/${communitySlug}`}
              className="pointer-event-child-none"
            >
              <Text size="p4" color={theme.colors.primaryBase} type="semiBold">
                {f({
                  id: 'embeddedCommunity.moreForums',
                  defaultMessage: 'More forums',
                })}
              </Text>
            </Button>
          </Badge>
        </Carousel.Slide>
      )} */}
    </StyledCarousel>
  ) : null
}
